import { icons } from '../../../../configs/Icons';

const demoData = [
    {
        email: '-------------------',
        id: 10000115,
        name: '--------------',
        photoUrl: icons.avatar,
        demo: true
    }
];

function SearchedUser({ show, data, handelUserClick }) {
    const arr = data || demoData;

    // if (!data) {
    //     return null;
    // }
    if (!show) {
        return null;
    }
    if (data && !data?.length) {
        return (
            <div className="searched-user-container">
                <div className="searched-user-row selected">
                    <h2 className="title">No User Found!</h2>
                </div>
            </div>
        );
    }
    return (
        <div className="searched-user-container">
            {arr?.map((item) => (
                <div
                    key={item.id}
                    role="button"
                    tabIndex={-1}
                    onClick={() => handelUserClick(item)}
                    className="searched-user-row flex-row align-space-between"
                >
                    <div>
                        <div className="avatar">
                            <span>
                                <img src={icons.avatar} alt="avatar" />
                            </span>
                        </div>
                    </div>
                    <div>
                        <h2 className="title">
                            <span>{item.name || '--'}</span>
                        </h2>
                        <p className="sub-title">
                            <span>{item?.email || '--'}</span>
                        </p>
                    </div>
                </div>
            ))}{' '}
        </div>
    );
}

export default SearchedUser;
